import { DestinationType, RawDestinationType } from '../../../shared/interfaces/destination';

export function DestinationTypesFactory(
  rawDestinationTypes: RawDestinationType[]
): DestinationType[] {
  return rawDestinationTypes.map(DestinationTypeFactory);
}

export function DestinationTypeFactory(rawDestinationType: RawDestinationType): DestinationType {
  return {
    id: rawDestinationType.type,
    destinationType: rawDestinationType.type,
    displayName: rawDestinationType.display_name,
    description: rawDestinationType.description,
    logo: rawDestinationType.logo_url,
    logoDarkMode: rawDestinationType.dark_mode_logo_url || '',
    baseDestinationType: rawDestinationType.base_type
  };
}
